import { Div, PopupMenu } from "@tblabs/truffle";
import { AdminMiniButton } from "./AdminMiniButton";


export class AdminMenu extends Div
{
    constructor(menu: Record<string, string>)
    {
        super();

        const entries = Object.fromEntries(Object.entries(menu).map(([key, value]) => [key, () => window.location.hash = value]));

        const popup = new PopupMenu(entries, new AdminMiniButton("", ''));

        this.PositionRelative().FloatRight()
        
        this.Append(popup)
    }
}
